import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'polygon-overlay',
  templateUrl: './polygon-overlay.component.html',
  styleUrls: ['./polygon-overlay.component.css']
})
export class PolygonOverlayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
